import { render } from "./DeliveryZones.vue?vue&type=template&id=69190800"
import script from "./DeliveryZones.vue?vue&type=script&lang=js"
export * from "./DeliveryZones.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/order-confirm-crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__